/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SrvProceedingMaintenanceExpenseResponse
 */
export interface SrvProceedingMaintenanceExpenseResponse {
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingMaintenanceExpenseResponse
     */
    personCount: number;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingMaintenanceExpenseResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the SrvProceedingMaintenanceExpenseResponse interface.
 */
export function instanceOfSrvProceedingMaintenanceExpenseResponse(value: object): value is SrvProceedingMaintenanceExpenseResponse {
    if (!('personCount' in value) || value['personCount'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SrvProceedingMaintenanceExpenseResponseFromJSON(json: any): SrvProceedingMaintenanceExpenseResponse {
    return SrvProceedingMaintenanceExpenseResponseFromJSONTyped(json, false);
}

export function SrvProceedingMaintenanceExpenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingMaintenanceExpenseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personCount': json['personCount'],
        'amount': json['amount'],
    };
}

export function SrvProceedingMaintenanceExpenseResponseToJSON(json: any): SrvProceedingMaintenanceExpenseResponse {
    return SrvProceedingMaintenanceExpenseResponseToJSONTyped(json, false);
}

export function SrvProceedingMaintenanceExpenseResponseToJSONTyped(value?: SrvProceedingMaintenanceExpenseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personCount': value['personCount'],
        'amount': value['amount'],
    };
}

